import { render, staticRenderFns } from "./Form-plugins.vue?vue&type=template&id=3927c6e6&"
import script from "./Form-plugins.vue?vue&type=script&lang=js&"
export * from "./Form-plugins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports